<template>
    <page-wrap>
        <el-dialog
                title="选择商品"
                :modal="false"
                :fullscreen="true"
                @close="close()"
                :visible="handle"
                :close-on-click-modal="false"
        >
            <search-wrap>
                <el-form
                        :model="search"
                        label-width="100px"
                        size="mini"
                        onsubmit="return false"
                >
                    <el-row>
                        <el-col :span="18">
                            <div class="bg">
                                <el-form-item
                                        label="商品名:"
                                        label-width="100px"
                                >
                                    <el-input
                                            style="width:150px"
                                            v-model="search.g_name"
                                            placeholder="请输入商品名"
                                            @keyup.enter.native="searchSubmit()"
                                            clearable
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                        label="商品分类:"
                                        label-width="120px"
                                >
                                    <el-input placeholder="请选择商品分类" v-model="c_name" readonly class="pl50">
                                        <el-button type="info" slot="append" icon="el-icon-search"
                                                   @click="handle_ca = true">
                                        </el-button>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <el-button
                                    type="primary"
                                    size="mini"
                                    @click="searchSubmit()"
                            >查询
                            </el-button>
                            <el-button type="danger" size="mini" @click="onClear()" icon='el-icon-refresh'
                                       title="重置搜索条件">
                                重置
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </search-wrap>
            <table-wrap>
                <el-table
                        :data="table"
                        ref="singleTable"
                        v-loading="loading"
                        tooltip-effect="dark"
                        highlight-current-row
                        @current-change="handleCurrentChange"
                        @row-click="row_click"
                        :height="tableHeight"
                        :row-key="getRowKeys">
                    <el-table-column label="封面" min-width='60'>
                        <template slot-scope="scope">
                            <img :src="scope.row.g_image" alt="" width="70">
                        </template>
                    </el-table-column>
                    <el-table-column label="商品名称" prop="g_name" min-width='100'>
                    </el-table-column>
                    <el-table-column label="商品分类" prop="c_name" min-width='100'>
                    </el-table-column>
                    <el-table-column label="金额" prop="price" min-width='100'>
                    </el-table-column>
                </el-table>
            </table-wrap>
            <div slot="footer">
                <!--<el-button-->
                <!--size="mini"-->
                <!--type="primary"-->
                <!--@click="close()"-->
                <!--&gt;确 定-->
                <!--</el-button>-->
                <pagination
                        :data="pagination"
                        @submit="searchSubmit"
                />
            </div>
        </el-dialog>
        <Category :handle="handle_ca" @closeSelf="closeCategory" @confirm="callbackCat" :c_id="search.c_id"/>
    </page-wrap>
</template>
<script>
    import Category from '../../components/dialog/Category'

    export default {
        components: {
            Category
        },
        computed: {
        },
        props: {
            handle: {
                type: Boolean,
                default: false
            },
        },
        watch: {
            handle: function (data) {
                this.handle = data;
            },
        },
        mounted() {
            this.searchSubmit();
        },
        updated(){
            this.$nextTick(()=>{
                if(document.getElementsByClassName('tableWrap')[0]){
                    let p = document.getElementsByClassName('paginationWrap')[0].offsetTop;
                    let t = document.getElementsByClassName('tableWrap')[0].offsetTop;
                    let h = document.getElementsByClassName('el-table__header-wrapper')[0].offsetHeight;
                    this.tableHeight =  450;
                }
            });
        },
        data() {
            return {
                loading: false,
                pagination: {currentPage: 1, pageSize: 20, total: 0},
                table: [],
                search: {g_name: "", c_id: 0},
                c_name: '',
                handle_ca: false,
                tableHeight: null,
            };
        },
        methods: {
            row_click(row, column, event) {
                this.$emit("select", row);
                this.close()
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChange(val) {
                this.$emit("select", val);
                this.close()
            },
            getRowKeys(row) {
                return row.g_id;
            },
            searchSubmit: function (pagination = null) {
                let that = this;
                if (pagination !== null) {
                    that.pagination = pagination;
                } else {
                    that.pagination.currentPage = 1;
                }
                if (this.loading) {
                    return;
                }
                this.loading = true;
                this.$ajax
                    .post("/goods/Goods/index", {
                        search: that.search,
                        paginate: that.pagination
                    })
                    .then(function (res) {
                        if (res.data.error === 0) {
                            that.table = res.data.data.data;
                            that.pagination.total = res.data.data.total;
                            that.loading = false;
                        }
                    })
                    .catch(function (err) {
                        that.$message("网络错误！请联系管理员");
                        that.loading = false;
                    });
            },
            onClear() {
                for (let key in this.search) {
                    this.search[key] = "";
                }
                this.search.c_id = 0;
                this.c_name = '';
            },
            close() {
                this.$emit("close", false);
            },
            callbackCat(data) {
                this.handle_ca = false;
                this.search.c_id = data.last_value;
                this.c_name = data.last_label;
            },
            closeCategory() {
                this.handle_ca = false;
            },
        }
    };
</script>

<style>
    .el-table__body tr.current-row > td {
        background-color: #bceeff;
    }

    #xzkh2 .is-fullscreen {
        width: 70%;
        height: 100%;
        overflow: hidden;
    }

    #xzkh2 .searchWrap {
        min-width: 900px;
    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/GoodsBin.vue